import Event from '../../core/Event';

export default class EstimationsPlaceFailed extends Event {
    public static type = 'EstimationsPlaceFailed';

    constructor() {
        super(EstimationsPlaceFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsPlaceFailed.ts